export default "__VITE_ASSET__DWKcsZc4__"